import { Component, Input } from '@angular/core';
import { IonCol, IonLabel, IonRow } from '@ionic/angular/standalone';
import { CONSTS } from './travel-section.constants';

@Component({
  selector: 'app-travel-section',
  imports: [IonRow, IonCol, IonLabel],
  templateUrl: './travel-section.component.html',
  styleUrl: './travel-section.component.scss',
})
export class TravelSectionComponent {
  @Input() origAddress!: string;
  @Input() destAddress!: string;
  readonly CONSTANTS = CONSTS;
}
